<form [formGroup]="formGroup">
  <mat-form-field appearance="fill" floatLabel="always" [ngStyle]="{'margin-left': field.level * LEVEL_OFFSET + 'px',  width: 'calc(100% - ' + field.level * LEVEL_OFFSET + 'px)'}">
    @if (inputType !== 'boolean') {
      <mat-label>{{field.label | desnake}} <span class="required">{{field.required ? '*' : ''}}</span></mat-label>
    }
    @if (!field.values && inputType !== 'array' && inputType !== 'html' && inputType !== 'boolean' && !field.foreignKeyTable) {
      <input [type]="inputType" matInput placeholder="" [formControlName]="field.name">
    }
    @if (inputType === 'html') {
      <textarea matInput [formControlName]="field.name"></textarea>
    }
    @if (inputType === 'html') {
      <div class="htmlview" [innerHtml]="fieldValue"></div>
    }
    @if (inputType === 'array') {
      <app-tags [tags]="initialFieldValue" (changeEvent)="changed($event)"></app-tags>
    }
    @if (!field.values && inputType !== 'boolean' && field.foreignKeyTable) {
      <mat-select [formControlName]="field.name" [placeholder]="foreignKeyValues.length > 0 ? '' : 'You must first add one or more ' + field.foreignKeyTable">
        <mat-option>
          <ngx-mat-select-search [formControlName]="searchFieldName" noEntriesFoundLabel="No matches" placeholderLabel="Find..."></ngx-mat-select-search>
        </mat-option>
        @for (item of currentValues; track item) {
          <mat-option [value]="item.value">{{item.name}}</mat-option>
        }
      </mat-select>
    }
    @if (field.values && inputType !== 'boolean') {
      <mat-select [formControlName]="field.name">
        @for (value of field.values; track value) {
          <mat-option [value]="value">{{value}}</mat-option>
        }
      </mat-select>
    }
    @if (inputType === 'boolean') {
      <div class="toggle">
        <span class="togglelabel">{{field.label | desnake}}</span>
        <mat-slide-toggle [checked]="$safeNavigationMigration(formGroup.get(field.name)?.value)" (change)="formGroup.get(field.name)?.setValue($event.checked)" labelPosition="before"></mat-slide-toggle>
      </div>
    }
    @if (inputType === 'color') {
      <input class="colorpicker" matInput [name]="field.name" autocomplete="off" (colorPickerChange)="changed($event)" [colorPicker]="$safeNavigationMigration(formGroup.get(field.name)?.value)" [style.background]="formGroup.get(field.name)?.value" [cpOKButton]="true" [cpCancelButton]="true"/>
    }
    @if (inputType === 'boolean' || inputType === 'array') {
      <textarea matInput hidden></textarea>
    }
  </mat-form-field>
</form>
